import { render, staticRenderFns } from "./TableInput.vue?vue&type=template&id=1b306f7c&scoped=true"
import script from "./TableInput.vue?vue&type=script&lang=js"
export * from "./TableInput.vue?vue&type=script&lang=js"
import style0 from "./TableInput.vue?vue&type=style&index=0&id=1b306f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b306f7c",
  null
  
)

export default component.exports